import { Button } from '@mui/material';
import React from 'react';

import {
  NoActionsMessage,
  PrimaryActionGrid,
  PrimaryActionOption,
  SecondaryActionsRow,
  SectionTitle,
  SelectionContent,
} from './MobilePartActionsDialog.styles';
import { PartActionTypes } from '../../../../../../@types/partAction.type';

const PRIMARY_ACTIONS = ['install', 'remove', 'replace'];

interface PartActionSelectionStepProps {
  partActionTypes: PartActionTypes[];
  onSelectAction: (action: PartActionTypes) => void;
}

export const PartActionSelectionStep: React.FC<PartActionSelectionStepProps> = ({
  partActionTypes,
  onSelectAction,
}) => {
  if (partActionTypes.length === 0) {
    return <NoActionsMessage>No part actions available for this service</NoActionsMessage>;
  }

  const activeActions = partActionTypes.filter((a) => a.isActive);
  const primary = activeActions.filter((a) => PRIMARY_ACTIONS.includes(a.code));
  const secondary = activeActions.filter((a) => !PRIMARY_ACTIONS.includes(a.code));

  return (
    <SelectionContent>
      {primary.length > 0 && (
        <>
          <SectionTitle>Common Actions</SectionTitle>
          <PrimaryActionGrid>
            {primary.map((action) => (
              <PrimaryActionOption key={action.code} onClick={() => onSelectAction(action)}>
                {action.name}
              </PrimaryActionOption>
            ))}
          </PrimaryActionGrid>
        </>
      )}

      {secondary.length > 0 && (
        <>
          <SectionTitle>Other Actions</SectionTitle>
          <SecondaryActionsRow>
            {secondary.map((action) => (
              <Button
                key={action.code}
                variant="outlined"
                size="small"
                onClick={() => onSelectAction(action)}
                sx={{ textTransform: 'none', borderRadius: '8px' }}
              >
                {action.name}
              </Button>
            ))}
          </SecondaryActionsRow>
        </>
      )}
    </SelectionContent>
  );
};
